import { CORE_PATH } from '@shared/api/paths';

const MAIN_PATH = 'PastDebts';

export const path = `${CORE_PATH}/${MAIN_PATH}`;
